export default __webpack_public_path__ + "static/media/VolvoNovum-Light.c621199b.ttf";